import { Injectable } from '@angular/core';
import { HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';

import { Crud, CrudService, CustomHttp, ConfigServerService } from '../../../core';
import { CondicaoPagamento } from '../condicao-pagamento';
import { CondicaoPagamentoFilter } from '../filter';

@Injectable({
    providedIn: 'root'
})
export class CondicaoPagamentoCrudHttpService implements Crud<CondicaoPagamento> {
    resource = 'condicaopagamento';
    private pathApi: string;

    constructor(configServerService: ConfigServerService,
                private crudService: CrudService,
                private customHttp: CustomHttp) {
        this.pathApi = `${configServerService.getPathApi()}/${this.resource}`;
    }

    /** Pesquisa todos as condições cadastrados */
    search(): Observable<CondicaoPagamento[]> {
        return this.crudService.search<CondicaoPagamento>(this.resource);
    }

    searchWithFilter(filter: CondicaoPagamentoFilter): Observable<CondicaoPagamento[]> {
        // Params
        let params = new HttpParams()
        // Filter params
        if (filter) {
            params = filter.createParams(params);
        }

        return this.customHttp.get<CondicaoPagamento[]>(this.pathApi, {params});
    }

    /** Procura uma única condição através do seu ID */
    find(id: number): Observable<CondicaoPagamento> {
        return this.crudService.find<CondicaoPagamento>(this.resource, id);
    }

    /** Carrega uma única condição através do seu ID */
    load(id: number): Observable<CondicaoPagamento> {
        return this.crudService.load<CondicaoPagamento>(this.resource, id);
    }

    /** Insere uma nova condição */
    insert(entity: CondicaoPagamento): Observable<CondicaoPagamento> {
        return this.crudService.insert<CondicaoPagamento>(this.resource, entity);
    }

    /** Altera uma condição existente */
    update(entity: CondicaoPagamento): Observable<CondicaoPagamento> {
        return this.crudService.update<CondicaoPagamento>(this.resource, entity);
    }

    /** Exclui uma condição através do seu ID */
    delete(id: number): Observable<string> {
        return this.crudService.delete(this.resource, id);
    }
}
